import React from "react";

function FaqPage() {
  return (
    <div className="main-wrapper">
      <div className="container mx-auto py-6 lg:py-10">
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0  text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Home
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0  text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Frequently Ask Question
          </p>
        </div>

        <div className="main-background lg:p-10">
          <div className="mb-4 lg:mb-8">
            <p className="header-title-bold colors-blue text-2xl lg:text-3xl ">
              Frequently Ask Question
            </p>
          </div>

          <div className="my-5">
            <p className="mb-2 header-title-semi colors-blue text-lg lg:text-xl">
              Apakah BBLK Surabaya
            </p>
            <p className="header-content">
              BBLK Surabaya adalah singkatan dari Balai Besar Laboratorium
              Kesehatan Surabaya yang merupakan Unit Pelaksana Teknis (UPT)
              Direktorat Jenderal Pelayanan Kesehatan di Kementerian Kesehatan
              RI untuk bidang laboratorium kesehatan yang telah menerapkan Pola
              Pengelolaan Keuangan Badan Layanan Umum (PPK-BLU).
            </p>
          </div>

          <div className="my-5">
            <p className="mb-2 header-title-semi colors-blue text-lg lg:text-xl">
              Apa saja pelayanan di BBLK Surabaya
            </p>
            <div className="">
              <p className="header-content text-base lg:text-lg">
                A. Layanan Pemeriksaan Laboratorium
              </p>
              <div className="pl-10">
                <ul>
                  <li>
                    Pemeriksaan Patologi Klinik (Hematologi dan Kimia Klinik)
                  </li>
                  <li>Pemeriksaan Mikrobiologi Klinik</li>
                  <li>Pemeriksaan Bakteri Sanitasi</li>
                  <li>Pemeriksaan Imunologi</li>
                  <li>Pemeriksaan Patologi Anatomi (Pap Smear)</li>
                  <li>Pemeriksaan Kimia Kesehatan</li>
                </ul>
              </div>
            </div>
            <div className="">
              <p className="header-content text-base lg:text-lg">
                B. Layanan Pemeriksaan Penunjang Medik
              </p>
              <div className="pl-10">
                <ul>
                  <li>Pemeriksaan Radiologi Diagnostik</li>
                  <li>Pemeriksaan Elektrocardiography (ECG)</li>
                  <li>Pemeriksaan Ultrasonography (USG)</li>
                  <li>Pemeriksaan Treadmill</li>
                  <li>Pemeriksaan Audiometri</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="my-5">
            <p className="mb-2 header-title-semi colors-blue text-lg lg:text-xl">
              Bagaimana Waktu Pelayanan
            </p>
            <div className="">
              <p className="header-content text-base lg:text-lg">1. Jam Buka</p>
              <div className="pl-10">
                <ul>
                  <li>Senin – Jum’at: 06.00 – 21.00 WIB</li>
                  <li>Sabtu : 06.00 – 12.00 WIB</li>
                  <li>Minggu : Tutup</li>
                </ul>
              </div>
            </div>
            <div className="">
              <p className="header-content text-base lg:text-lg">
                2. Penerimaan Bahan / Sampel
              </p>
              <div className="pl-10">
                <ul>
                  <li>Senin – Jum’at: 06.00 – 19.00 WIB</li>
                  <li>Sabtu : 06.00 – 11.00 WIB</li>
                </ul>
              </div>
            </div>
            <div className="">
              <p className="header-content text-base lg:text-lg">
                3. Penyerahan Hasil
              </p>
              <div className="pl-10">
                <ul>
                  <li>Senin – Jum’at: 09.00 – 21.00 WIB</li>
                  <li>Sabtu : 09.00 – 12.00 WIB</li>
                </ul>
              </div>
            </div>
            <div className="">
              <p className="header-content text-base lg:text-lg">
                4. Hari Libur Nasional
              </p>
              <div className="pl-10">
                <ul>
                  <li>
                    <b>Buka</b> : Pukul 06.00 – 12.00{" "}
                  </li>
                  <li>
                    <b>Tutup </b>:
                  </li>
                  <ul className="ml-5">
                    <li>HUT Kemerdekaan RI</li>
                    <li>Hari Raya Idul Fitri</li>
                    <li>Hari Raya Idul Adha</li>
                    <li>Hari Raya Natal</li>
                    <li>Tahun Baru</li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqPage;
